module.exports = __webpack_public_path__ + "img/Stampcard 10 Icon - charcoal.e26cdc80.svg";